import type { WebsiteRevisionSummary } from './WebsiteBuilderService'

export interface RevisionActionState {
  canView: boolean
  canCompare: boolean
  canRestore: boolean
  canUndo: boolean
  canPublish: boolean
}

export function revisionActionState(revision: WebsiteRevisionSummary, currentRevision: number, busy = false): RevisionActionState {
  const current = revision.revision === currentRevision
  return {
    canView: !busy,
    canCompare: !busy && revision.parentRevision !== null,
    canRestore: !busy && !current,
    canUndo: !busy && current && revision.parentRevision !== null,
    canPublish: !busy && current,
  }
}
